module.exports = __webpack_public_path__ + "img/16581253_L.56446964.png";